import config from '../../../config';

const baseUrl = `${config.apiUrl()}/BackOffice/FleetEntityLinks`;

export default {
  addFleetEntityLinkUrl: (): string => `${baseUrl}`,
  deleteFleetEntityLinks: (fleetEntityLinkId): string => `${baseUrl}/${fleetEntityLinkId}`,
  editFleetEntityLinks: (fleetEntityLinkId): string => `${baseUrl}/${fleetEntityLinkId}`,
};
